import { render, staticRenderFns } from "./ApartmanAlacakFormWizard.vue?vue&type=template&id=55ab0d56"
import script from "./ApartmanAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./ApartmanAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports